import { SidebarProvider } from "./ui/Sidebar";
import { AppSidebar } from "./AppSidebar";
import { Outlet } from "react-router-dom";
import AppFooter from "./AppFooter";
import { Toaster } from "./Toaster";
import { Support } from "./Support";
import LoginNotificationListener from "./LoginNotificationListener";

export default function AppLayout({ isStorageSideBar = false }) {
	return (
		<div className="bg-[#f3f5f9]">
			<SidebarProvider>
				<AppSidebar isStorageSideBar={isStorageSideBar} />
				<Support />
				<Toaster />
				<LoginNotificationListener />
				<main className="flex h-full w-full flex-col justify-between">
					<Outlet />
					<AppFooter />
				</main>
			</SidebarProvider>
		</div>
	);
}
